import styled from 'styled-components'

export default styled.section`
  width: 620px;
  background-color: ${ ({ theme }) => theme.colors.white };
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  header {
    min-height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px;

    h3 {
      color: ${ ({ theme }) => theme.colors.primary };
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 20px;
      margin: 0;
    }
  }

  > section {
    padding: 0 50px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  footer {
    min-height: 104px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px;
    position: relative;

    button {
      width: 220px;
    }
  }

  @media screen and (max-width: 768px){
    width: 100%;

    header {
      padding: 0 10px !important;
    }

    section {
      padding: 0 10px !important;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    footer {
      padding: 0 10px !important;
      button {
        width: 130px !important;
      }
    }
  }
`
